import { ChangeDetectionStrategy, Component } from '@angular/core';

import { MarketHelpConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';
import { WinGameFixture } from '@frontend/sports/racing/feature/models';

import { HorsesFixtureHelper } from '../../../../horse-racing-shared/services/horses-fixture-helper.service';
import { HorsesFixtureMarketHelper } from '../../../../horse-racing-shared/services/horses-fixture-market-helper.service';
import { HorsesFixtureParticipantHelper } from '../../../../horse-racing-shared/services/horses-fixture-participant-helper.service';
import { HorsesFixturePricingHelper } from '../../../../horse-racing-shared/services/horses-fixture-pricing-helper.service';
import { HorsesFixtureTranslationHelper } from '../../../../horse-racing-shared/services/horses-fixture-translation-helper.service';
import { EachWayMarketHelperService } from '../../../../option-group/each-way-market-helper.service';
import { GreyhoundTrackingService } from '../../../common/greyhound-tracking.service';
import { RacingService } from '../../../services/racing-service';
import { GreyhoundsRaceComponent } from './greyhounds-race.component';

@Component({
    selector: 'ms-greyhounds-derived-race',
    templateUrl: './greyhounds-race.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class GreyhoundsDerivedRaceComponent extends GreyhoundsRaceComponent {
    constructor(
        horsesFixturePricingHelper: HorsesFixturePricingHelper,
        sitecore: Sitecore,
        horsesFixtureMarketHelper: HorsesFixtureMarketHelper,
        greyhoundTrackingService: GreyhoundTrackingService,
        horsesFixtureHelper: HorsesFixtureHelper,
        horsesFixtureParticipantHelper: HorsesFixtureParticipantHelper,
        horsesFixtureTranslationHelper: HorsesFixtureTranslationHelper,
        eachWayMarketHelperService: EachWayMarketHelperService,
        racingService: RacingService,
        marketHelpConfig: MarketHelpConfig,
        urlHelper: UrlHelperService,
    ) {
        super(
            sitecore,
            horsesFixtureMarketHelper,
            horsesFixturePricingHelper,
            greyhoundTrackingService,
            horsesFixtureHelper,
            horsesFixtureParticipantHelper,
            horsesFixtureTranslationHelper,
            eachWayMarketHelperService,
            racingService,
            marketHelpConfig,
            urlHelper,
        );
    }

    override setViewModel(fixture: WinGameFixture, resetSelectedMarket: boolean): void {
        this.setDerivedMarketViewModel(fixture, resetSelectedMarket);
    }

    override setSelectedMarket(selectedTabItem: string) {
        this.setDerivedSelectedMarket(parseInt(selectedTabItem));
    }
}
